import React, { FC } from "react";

interface ProsConsType {
    prosCons: prosAndCons;
    compareWith: string;
}
interface prosAndCons {
    pros: string[];
    cons: string[];
}

const ProsConsBox: FC<ProsConsType> = ({ prosCons, compareWith }) => {
    return (
        <>
            <h2 className="mb-6 md:mb-10 text-center">
                Is {compareWith} The Right {compareWith === "wati" ? "Fit" : "Tool"} For Your Business?
            </h2>
            <div className="pros-cons flex justify-center gap-5 flex-wrap">
                <div className="pros">
                    <div>
                        <p className=" text-2xl m-0">Pros:</p>
                        <ul className="p-0">
                            {prosCons.pros.map((para) => {
                                return (
                                    <li key={para} className="my-5">
                                        <p className="text-lg">{para}</p>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <div className="pros cons">
                    <div>
                        <p className=" text-2xl m-0">Cons:</p>
                        <ul className="p-0">
                            {prosCons.cons.map((para) => {
                                return (
                                    <li key={para} className="my-5">
                                        <p className="text-lg">{para}</p>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProsConsBox;
